import React, { useState, ChangeEvent, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'utils/axios';
import './ForgotPassword.css';

interface ForgotPasswordProps {
  onBackToLogin?: () => void;
}

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setSubmitting(true);

    try {
      const { data } = await axios.post('/v1/api/forgot-password', {
        email: email.trim(),
      });
      setMessage(data?.message || 'Password reset instructions have been sent to your email.');
    } catch (err: any) {
      setError(err?.response?.data?.message || err.message || 'Unable to send password reset email.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleBackToLogin = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onBackToLogin) {
      onBackToLogin();
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="fp-container">
      <form className="fp-form" onSubmit={handleSubmit}>
        <h2 className="fp-title">Forgot Password</h2>
        {message && <div className="fp-alert fp-alert--success">{message}</div>}
        {error && <div className="fp-alert fp-alert--error">{error}</div>}
        <div className="fp-field">
          <label className="fp-label" htmlFor="email">Email Address</label>
          <input
            className="fp-input"
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={handleChange}
            required
          />
        </div>
        <button type="submit" className="fp-btn" disabled={submitting}>
          {submitting ? 'Sending...' : 'Reset Password'}
        </button>
        <p className="fp-loginPrompt">
          Remembered your password?{' '}
          <button type="button" className="fp-linkButton" onClick={handleBackToLogin}>
            Back to Login
          </button>
        </p>
      </form>
    </div>
  );
};

export default ForgotPassword;
